import { initSlider } from "../../ui";
import "./customer-reviews-section.scss";

document.addEventListener("DOMContentLoaded", () => {
  initSlider({
    containerSelector: ".js-jiffytransfers-landing-v2-customer-reviews-section-swiper",
    spaceBetween: 16
  });
});
